module.exports = __webpack_public_path__ + "static/media/71_tn.91915074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/71_tn.jpg
// module id = 557
// module chunks = 0